<template>
  <v-container style="min-height: calc(100vh - 124px);">
    <v-row>
      <v-col cols="12" md="12">
        <v-tabs
          v-model="tabsurat"
          show-arrows>
          <v-tab href="#tab-data" class="text-capitalize">
            <v-badge
              color="red"
              inline>
              <v-icon>mdi-text-box-check-outline</v-icon>
              Data
            </v-badge>
          </v-tab>
          <v-tab href="#tab-draft" class="text-capitalize">
            <v-icon>mdi-text-box-check-outline</v-icon> Draft Surat
          </v-tab>
        </v-tabs>
        <v-tabs-items :touchless="true" v-model="tabsurat">
          <v-tab-item value="tab-data">
            <v-card flat>
              <alertsp class="my-1" :alertdata="alertgetdata"></alertsp>
              <div class="text-center" v-if="loading.getdata">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <v-card-text class="px-0">
                <v-row justify="center" v-if="detaildata">
                  <v-col cols="12">
                    <div class="text-subtitle-1 font-weight-black">
                      {{ detaildata.kd_sl }}
                    </div>
                    <v-chip
                      class="my-1"
                      :color="detaildata.status_sl == 'siap' ? 'green' : 'red'"
                      text-color="white"
                      small>
                      {{ detaildata.status_sl }}
                    </v-chip>
                    <div class="text-subtitle-2">
                      {{ detaildata.nama_hal }}
                    </div>
                    <div class="text-subtitle-2 font-weight-bold">
                      {{ detaildata.judul_sl }}
                    </div>
                    <div class="text-subtitle-2">
                      at.<b>{{ detaildata.tgl_ajukan }}</b>
                    </div>
                    <v-divider class="my-3"></v-divider>
                    <div class="caption font-weight-black mb-1">
                      Pemohon:
                    </div>
                    <div class="text-subtitle-2">
                      <div v-if="dataprofile.nama">
                        <b>{{ dataprofile.nama }}</b>
                      </div>
                      ({{ detaildata.user_sl }})
                    </div>
                  </v-col>
                </v-row>
                <v-row justify="center" v-if="!detaildata">
                  <v-col cols="12">
                    Data tidak ditemukan!
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-draft" v-if="detaildata">
            <v-card flat>
              <!-- file surat -->
              <v-card-text
                class="px-0">
                <div>
                  <iframe
                    :src="getPdfView(detaildata.urlfile)"
                    class="pdf-embed-surat mt-3"
                    frameborder="0">
                  </iframe>
                </div> 
                <div>
                  <a :href="getPdfView(detaildata.urlfile)" target="_blank">Preview Draft Surat</a>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <!-- form -->
        <div class="my-3" v-if="detaildata">
          <v-form
            ref="formupdatesurat"
            v-model="formadd.valid"
            lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                  dense
                  v-if="detaildata.status_sl === 'permohonan'"
                  :disabled="!canchange"
                  :items="liststatus"
                  name="statussurat"
                  :rules="[rules.required]"
                  v-model="updatesurat.status_sl"
                  label="Status Surat*">
                </v-select>
                <v-text-field
                  dense
                  v-if="detaildata.status_sl !== 'permohonan'"
                  :disabled="true"
                  :readonly="true"
                  :value="detaildata.status_sl"
                  label="Status Surat"
                  name="status_sl">
                </v-text-field>
              </v-col>
              <v-col cols="12" v-if="updatesurat.status_sl === 'tolak'">
                <v-text-field
                  dense
                  :disabled="!canchange"
                  v-model="updatesurat.acc_note"
                  label="Catatan penolakan*"
                  :rules="[rules.required]"
                  name="acc_note">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <alertsp :alertdata="alertdata"></alertsp>
                <div class="text-center" v-if="loading.update">
                  <v-progress-circular
                    :width="3"
                    color="red"
                    indeterminate>
                  </v-progress-circular>
                </div>
                <v-btn
                  tile
                  depressed
                  large
                  color="primary"
                  class="mr-2"
                  :to="{ name: 'SLDosen', query: { tab: 'tab-acc-ver' } }">
                  Kembali
                </v-btn>
                <v-btn
                  tile
                  depressed
                  large
                  v-if="!loading.update && canchange"
                  :disabled="!formadd.valid"
                  color="success"
                  class="mr-2"
                  @click="submitUpdate">
                  Proses
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { getGdriveView } from '@/plugins/utils';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'SLVerDetail',
  props: ['kodesurat'],
  data: () => ({
    selectedItem: 1,
    alertgetdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
      changest: false,
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    prefix: process.env.VUE_APP_PREFIX,
    publickey: '123',
    detaildata: null,
    dataprofile: null,
    liststatus: ['proses', 'tolak'],
    datalist: [],
    dataaccunit: [],
    dataaccdir: [],
    updatesurat: {
      status_sl: '',
      kd_sl: '',
      no_sl: '',
      kode_hal: '',
      judul_sl: '',
    },
    listcategory: ['job-fair', 'motivation'],
    liststatusacc: [
      {
        value: 'permohonan',
        label: 'Perlu Acc',
      },
      {
        value: 'history',
        label: 'History Acc',
      },
      {
        value: 'semua',
        label: 'Semua',
      },
    ],
    liststatusdir: [
      {
        value: 'proses',
        label: 'Perlu Acc',
      },
      {
        value: 'history',
        label: 'History Acc',
      },
      {
        value: 'semua',
        label: 'Semua',
      },
    ],
    filterunit: {
      search: '',
      status: 'permohonan',
    },
    filterdir: {
      search: '',
      status: 'proses',
    },
    panduan: null,
    paramkamus: {
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
    wdayshow: true,
    tabsurat: null,
    canchange: true,
  }),
  mounted() {
    if (this.kodesurat) {
      this.getDetailSurat();
    }
    // update title
    this.$store.commit('UPDATE_TITLE', this.kodesurat);
  },
  filters: {
    dateToIndo(value) {
      return getDateTodayId(value);
    },
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'wday',
      'staticdata',
    ]),
  },
  methods: {
    getProfile(data) {
      // console.log(data);
      const strhex = data.user_sl +
        '' + this.hash;
      // console.log(strhex);
      const hashactv = sha256(strhex).toUpperCase();
      this.dataprofile = [];
      this.axios
        .get(
          this.apision + '/pegawai/' + data.user_sl + '&' + hashactv,
          {
            params: {},
            headers: {},
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.dataprofile = resdata.profile;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPdfView(url) {
      return getGdriveView(url);
    },
    getDetailSurat() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/suratlain/accver/' + this.kodesurat,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                if (resdata.data.detail.length > 0) {
                  this.detaildata = resdata.data.detail[0];
                  this.detaildata.tims = resdata.data.tims;
                  this.detaildata.urlttd = this.api + '/images/spm/' + this.detaildata.file_spm;
                  this.detaildata.urlqr = this.baseurl + '/verifikasi/' + this.detaildata.kd_sl;
                  this.detaildata.urlfile = this.api + '/upload/media/sl/' + this.detaildata.file_sl;
                  this.updatesurat.kd_sl = this.detaildata.kd_sl;
                  this.updatesurat.status_sl = this.detaildata.status_sl;
                  this.updatesurat.no_sl = this.detaildata.no_sl;
                  this.updatesurat.kode_hal = this.detaildata.kode_hal;
                  this.updatesurat.judul_sl = this.detaildata.judul_sl;
                  this.updatesurat.acc_note = this.detaildata.acc_note;
                  this.checkCanChange();
                  this.getProfile(this.detaildata);
                  // this.getTandatangan();
                } else {
                  this.alertgetdata.show = true;
                  this.alertgetdata.type = 'error';
                  this.alertgetdata.text = 'Data tidak ditemukan!';
                }
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatesurat.validate()) {
        if (this.tokenscr) {
          // console.log(this.updatesurat);
          this.loading.update = true;
          this.axios
            .put(
              this.api + '/api/suratlain/accvar',
              qs.stringify(
                this.updatesurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kd_sl + '" berhasil diperbaharui!';
                  this.getDetailSurat();
                  // this.$root.$emit('app-getnotifiaction');
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.update = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    checkCanChange() {
      this.canchange = true;
      const denystatus = ['siap', 'tolak', 'proses'];
      if (denystatus.indexOf(this.updatesurat.status_sl) >= 0) {
        this.canchange = false;
      }
    },
    getAccUnit() {
      if (this.tokenscr) {
        this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/suratlain/acc',
            {
              params: {
                status: this.filterunit.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.dataaccunit = resdata.data;
              }
            }
            this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changest = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
    QrcodeVue,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $main-color: #216185;

  .item-list-style{
    border-bottom: solid thin #BDBDBD;
  }
  .item-list-style:hover{
    color: $main-color;
    border-color: $main-color;
  }
  a.link-list-style{
    text-decoration: none;
    color: black;
  }
</style>
